<section class="position-relative overflow-hidden space" id="service-sec">
    <div class="container">
        <div class="row justify-content-between">
            <div class="col-xl-7">
                <div class="title-area service-3-titlebox text-center text-md-start">
                    <span class="sub-title text-anime-style-2">Our Services</span>
                    <h2 class="sec-title text-anime-style-2">Our Featured Solutions</h2>
                </div>
            </div>
            <div class="col-xl-5">
                <p class="service-3-text text-center text-md-start wow fadeInUp" data-wow-delay=".2s">Testing Services,
                    Custom application development, IT consulting services and our best services like Software
                    Development, Web Design, Apps Development, Internet Marketing Services.</p>

            </div>
        </div>
        <div class="slider-area">
            <div class="swiper th-slider has-shadow"
                data-slider-options='{"breakpoints":{"0":{"slidesPerView":1},"576":{"slidesPerView":"1"},"768":{"slidesPerView":"2"},"992":{"slidesPerView":"2"},"1200":{"slidesPerView":"3"},"1300":{"slidesPerView":"4"}}}'>
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="service-item style3 th-ani minh-525">
                            <div class="service-item_img global-img">
                                <img src="assets/img/service/service_3_1.jpg" alt="Android Development" />
                            </div>
                            <div class="service-content">
                                <h3 class="box-title"><a routerLink="/android-development">Android Development</a></h3>
                                <p class="service-text">AI refers to systems that simulate human intelligence to perform
                                    tasks such as reasoning,</p>
                                <a routerLink="/android-development" class="th-btn style4 th-icon">View Details <i
                                        class="fa-light fa-arrow-right-long"></i></a>
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="service-item style3 th-ani minh-525">
                            <div class="service-item_img global-img">
                                <img src="assets/img/service/service_3_6.jpg" alt="iOS Development" />
                            </div>
                            <div class="service-content">
                                <h3 class="box-title"><a routerLink="/ios-development">iOS Development</a></h3>
                                <p class="service-text">Xipe Tech delivers innovative iOS development solutions,
                                    creating high-performance, user-friendly apps tailored to client needs.</p>
                                <a routerLink="/ios-development" class="th-btn style4 th-icon">View Details <i
                                        class="fa-light fa-arrow-right-long"></i></a>
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="service-item style3 th-ani minh-525">
                            <div class="service-item_img global-img">
                                <img src="assets/img/service/service_3_3.jpg" alt="Laravel Development" />
                            </div>
                            <div class="service-content">
                                <h3 class="box-title"><a routerLink="/services">Laravel Development</a></h3>
                                <p class="service-text">Xipe Tech specializes in Laravel development, building secure,
                                    scalable, and high-performing web applications for diverse business needs.</p>
                                <a routerLink="/services" class="th-btn style4 th-icon">View Details <i
                                        class="fa-light fa-arrow-right-long"></i></a>
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="service-item style3 th-ani minh-525">
                            <div class="service-item_img global-img">
                                <img src="assets/img/service/service_3_4.jpg" alt="Python Development" />
                            </div>
                            <div class="service-content">
                                <h3 class="box-title"><a routerLink="/services">Python Development</a></h3>
                                <p class="service-text">Xipe Tech offers expert Python development, building scalable,
                                    efficient, and secure applications tailored to diverse business requirements.</p>
                                <a routerLink="/services" class="th-btn style4 th-icon">View Details <i
                                        class="fa-light fa-arrow-right-long"></i></a>
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="service-item style3 th-ani minh-525">
                            <div class="service-item_img global-img">
                                <img src="assets/img/service/service_3_5.jpg" alt="WordPress Development" />
                            </div>
                            <div class="service-content">
                                <h3 class="box-title"><a routerLink="/services">WordPress Development</a></h3>
                                <p class="service-text">Xipe Tech offers expert WordPress development, building
                                    responsive, secure, and customizable websites to enhance your online presence.</p>
                                <a routerLink="/services" class="th-btn style4 th-icon">View Details <i
                                        class="fa-light fa-arrow-right-long"></i></a>
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="service-item style3 th-ani minh-525">
                            <div class="service-item_img global-img">
                                <img src="assets/img/service/sv-1.jpg" alt="Magento Development" />
                            </div>
                            <div class="service-content">
                                <h3 class="box-title"><a routerLink="/services">Magento Development</a></h3>
                                <p class="service-text">Xipe Tech specializes in Magento development, building robust,
                                    scalable, and customized e-commerce solutions for enhanced business growth.</p>
                                <a routerLink="/services" class="th-btn style4 th-icon">View Details <i
                                        class="fa-light fa-arrow-right-long"></i></a>
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="service-item style3 th-ani minh-525">
                            <div class="service-item_img global-img">
                                <img src="assets/img/service/service_3_2.jpg" alt="Ai Technology" />
                            </div>
                            <div class="service-content">
                                <h3 class="box-title"><a routerLink="/services">Ai Technology</a></h3>
                                <p class="service-text">Xipe Tech harnesses AI technology to build intelligent,
                                    data-driven solutions that enhance efficiency, innovation, and user experiences.</p>
                                <a routerLink="/services" class="th-btn style4 th-icon">View Details <i
                                        class="fa-light fa-arrow-right-long"></i></a>
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="service-item style3 th-ani minh-525">
                            <div class="service-item_img global-img">
                                <img src="assets/img/service/service_3_4.jpg" alt="NodeJs Development" />
                            </div>
                            <div class="service-content">
                                <h3 class="box-title"><a routerLink="/services">NodeJs Development</a></h3>
                                <p class="service-text">Xipe Tech specializes in Node.js development, building fast,
                                    scalable, and secure server-side applications for diverse business needs.</p>
                                <a routerLink="/services" class="th-btn style4 th-icon">View Details <i
                                        class="fa-light fa-arrow-right-long"></i></a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="service-3-btn text-center mt-60">
            <a routerLink="/services" class="th-btn black-btn th-icon">View All Services <i
                    class="fa-light fa-arrow-right-long"></i></a>
        </div>
    </div>
</section>